export var CUI_Theme = 'cuiTheme';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/ThemeProvider/shared.js
// module id = 2030
// module chunks = 12